<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="green" dark v-bind="attrs" v-on="on">
        新增 <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-container class="px-3 my-container">
      <!-- <v-card-title class="headline">编辑</v-card-title> -->

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>新增建设主体</h1></v-card-title>

        <!-- ['10001','潘金云','330421196904152048','40','缪家村','西窑洞浜１３号'], -->
        <!-- <v-divider class="mx-4 my-10"></v-divider> -->
        <v-row>
          <v-text-field
            v-model="temp.garden_name"
            color="yellow darken-3"
            label="小区名称"
            required
            class="mx-6"
            style="width:120px"
          ></v-text-field>

          <v-text-field
            v-model="temp.totals"
            color="yellow darken-3"
            label="总套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="temp.large"
            color="yellow darken-3"
            label="大户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="temp.middle"
            color="yellow darken-3"
            label="中户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="temp.small"
            color="yellow darken-3"
            label="小户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="temp.construction_unit"
            color="yellow darken-3"
            label="施工单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="temp.construct_unit"
            color="yellow darken-3"
            label="建设单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="temp.supervision_unit"
            color="yellow darken-3"
            label="监理单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="temp.design_unit"
            color="yellow darken-3"
            label="设计单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="temp.survey_unit"
            color="yellow darken-3"
            label="勘察单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
        </v-row>
        
        <v-row>
          <v-text-field
            v-model="temp.invest_fee"
            color="yellow darken-3"
            label="项目总投资(万元)"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.land_fee"
            color="yellow darken-3"
            label="其中土地成本(亿元)"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.construction_fee"
            color="yellow darken-3"
            label="建安成本（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.other_fee"
            color="yellow darken-3"
            label="其他费用（加成10%+9%税金）（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          </v-row>
        
        <v-row>
          <v-text-field
            v-model="temp.loan_fee"
            color="yellow darken-3"
            label="银行贷款情况（贷款金额）（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.loan_rate"
            color="yellow darken-3"
            label="贷款利率（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.construction_interest"
            color="yellow darken-3"
            label="建设期利息（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.repayment"
            color="yellow darken-3"
            label="还款周期（年限及还本期）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
        <v-row>
        <v-text-field
            v-model="temp.total_area"
            color="yellow darken-3"
            label="总可销售面积（万平方米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.sale_area"
            color="yellow darken-3"
            label="可销售面积（万平方米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.sale_price"
            color="yellow darken-3"
            label="可售面积建设成本单价（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.taxes_fee"
            color="yellow darken-3"
            label="每平方加成、税金成本（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.tax_price"
            color="yellow darken-3"
            label="含代建费+税费的单价（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
      <v-row>
        <v-text-field
            v-model="temp.dpt_fee"
            color="yellow darken-3"
            label="预计大平台缴纳（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.nfjj_fee"
            color="yellow darken-3"
            label="预计农房集聚缴纳（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.empty_fee"
            color="yellow darken-3"
            label="空置房缴纳（按加成亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.empty_diff"
            color="yellow darken-3"
            label="空置房差价"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.diff_fee"
            color="yellow darken-3"
            label="差额部分（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="temp.construction_time"
            color="yellow darken-3"
            label="施工时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
         
          <v-text-field
            v-model="temp.completed_time"
            color="yellow darken-3"
            label="竣工时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          
          
          <v-text-field
            v-model="temp.expected_time"
            color="yellow darken-3"
            label="拟交付时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-menu
            v-model="delivery_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="temp.delivery_time"
                label="交房时间"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="temp.delivery_time"
              @input="delivery_menu = false"
            ></v-date-picker>
          </v-menu>
          
        </v-row>
        <v-row>
          <v-text-field
            v-model="temp.total_property"
            color="yellow darken-3"
            label="总物业费"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="temp.government_property"
            color="yellow darken-3"
            label="政府承担"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

          <v-text-field
            v-model="temp.household_property"
            color="yellow darken-3"
            label="农户承担"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

         
        </v-row>
        <v-row>
          <v-text-field
            v-model="temp.remark"
            color="yellow darken-3"
            label="备注"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelAddDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmAddDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
</template>

<script>
import { createBuild } from "@/api/builds";
// import { ModelListSelect } from "vue-search-select";
export default {
  name: "AddBuildDialog",
  components: {},

  data: () => ({
    objectItem: {},
    stringItem: "",
    dialog: false,
    construction_menu:"",
    completed_menu:"",
    delivery_menu:"",
    temp: {
      garden_name: "",
      totals: "",
      construction_unit: "",
      construct_unit: "",
      supervision_unit: "",
      design_unit: "",
      invest_fee: "",
      large: "",
      middle: "",
      small: "",
      construction_time: "",
      completed_time: "",
      delivery_time: "",
      total_property: "",
      government_property: "",
      household_property: "",
    }
  }),
  mounted() {},
  methods: {
    confirmAddDialog() {
      const tempData = this.temp;
      console.log(tempData);
      createBuild(tempData).then(() => {
        this.dialog = false;
        this.temp = {};
        this.$parent.getList();
      });
    },

    cancelAddDialog() {
      this.dialog = false;
      this.temp = {};
    }
  }
};
</script>

<style scoped>
.my-container {
  background-color: rgba(90, 90, 90, 0.9);
}
</style>
